export const posts = [
  {
    slug: "living-philosophy",
    title: "My Living Philosophy as a Builder",
    date: "12-20-2025",
    excerpt:
      "Curiosity, restraint, and intentional creation — the principles that shape how I live and build.",
    content: [
      "I believe life is something you build, not something you rush through.",
      "Curiosity is my compass. I question systems, habits, and defaults — not to rebel, but to understand. Understanding creates freedom.",
      "I value restraint. Not everything needs to be optimized, posted, or monetized. Some things are meant to compound quietly.",
      "I build with people in mind. Technology should reduce friction, not increase noise. The best systems feel invisible.",
      "I believe consistency beats intensity. Small deliberate actions, repeated daily, shape identity.",
      "And finally — creativity is a responsibility. If you’re capable of building something that helps others think, feel, or live better, you probably should."
    ],
    tags: ["Philosophy", "Building", "Identity"]
  },

  {
  slug: "building-before-belonging",
  title: "Building Before Belonging",
  date: "12-21-2025",
  excerpt: "Why I stopped chasing approval, identity labels, and belonging — and started building first.",
  tags: ["Philosophy", "Identity", "Growth"],
  content: [
    "For a long time, I believed that belonging came first.",
    "I thought once I found the right group, the right label, or the right space, everything else would fall into place. Confidence. Direction. Purpose.",
    "But the truth is, belonging never arrived until I stopped waiting for it.",
    "What I’ve learned is that belonging is not something you discover — it’s something that forms *after* consistent action.",
    "When you build, you naturally attract people who resonate with what you’re creating. When you wait, you end up reshaping yourself to fit rooms you don’t belong in.",
    "I spent years trying to explain myself before I had anything solid to point to. Now I let the work speak first.",
    "Building creates gravity. Belonging follows."
  ]
},
{
  slug: "consistency-is-quiet",
  title: "Consistency Is Quiet",
  date: "12-22-2025",
  excerpt: "Real progress doesn’t announce itself. It happens in silence, repetition, and patience.",
  tags: ["Discipline", "Mindset", "Self-Improvement"],
  content: [
    "Consistency is not loud.",
    "It doesn’t feel cinematic. There’s no dramatic turning point where everything suddenly clicks.",
    "Most days, consistency feels boring. Repetitive. Almost pointless.",
    "You show up, do the work, and nothing seems to change. No applause. No validation.",
    "But consistency compounds in ways motivation never can.",
    "Motivation depends on emotion. Consistency depends on commitment.",
    "Every skill I have now came from doing something poorly for a long time before doing it well.",
    "If you wait to feel inspired, you’ll always be behind. If you build a habit, progress becomes inevitable.",
    "Consistency is quiet — but it’s undefeated."
  ]
},
{
  slug: "why-i-build-in-public",
  title: "Why I Build in Public",
  date: "12-21-2025",
  excerpt: "Sharing unfinished work, imperfect ideas, and evolving thoughts is uncomfortable — and necessary.",
  tags: ["Building", "Technology", "Philosophy"],
  content: [
    "I used to believe that I needed everything figured out before sharing it.",
    "Perfect idea. Perfect execution. Perfect explanation.",
    "That mindset kept me silent for years.",
    "Building in public changed that.",
    "When you share early, you remove the illusion that progress is linear. People see the mistakes, the pivots, and the uncertainty.",
    "It’s uncomfortable — but it’s honest.",
    "Building in public keeps me accountable. It forces clarity. It turns ideas into something real.",
    "More importantly, it reminds me that growth doesn’t happen behind closed doors.",
    "The goal isn’t to look impressive. The goal is to keep moving forward — visibly."
  ]
}

];
